const AXES = [
  { key: "self-interest", axisOrder: 1, sliderOrder: 1 },
  { key: "fear", axisOrder: 2, sliderOrder: 4 },
  { key: "ideology", axisOrder: 3, sliderOrder: 2 },
  { key: "friends-and-family", axisOrder: 4, sliderOrder: 3 },
  { key: "peer-pressure", axisOrder: 5, sliderOrder: 5 },
  { key: "money", axisOrder: 6, sliderOrder: 6 },
];

function keysOrderedBy(order) {
  return AXES.toSorted((left, right) => left[order] - right[order]).map(
    ({ key }) => key,
  );
}

export const AXIS_KEYS = keysOrderedBy("axisOrder");
export const SLIDER_KEYS = keysOrderedBy("sliderOrder");

export const DEFAULT_VALUES = Object.fromEntries(
  SLIDER_KEYS.map((key) => [key, 50]),
);
